import * as yup from "yup";

export const validationSchemaEditeOrderForm = yup.object().shape({
  nameRecipient: yup.string().required("Это поле обязательное!"),
  phoneNumber: yup.string().required("Это поле обязательное!"),
});
